import {XHTTP} from '@/shared/xhttp';
import {ClientService} from "@/xhttp/ClientService";

@XHTTP(ClientService, '/clients')
export class Client {

	private _id: number;
	private _name: string;
	private _email: string;
	private _address: string;
	private _zipCode: string;
	private _town: string;
	private _phone: string;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get name(): string {
		return this._name;
	}

	public get email(): string {
		return this._email;
	}

	public get address(): string {
		return this._address;
	}

	public get zipCode(): string {
		return this._zipCode;
	}

	public get town(): string {
		return this._town;
	}

	public get fullAddress(): string {
		if (this.address && this.zipCode && this.town) {
			return (this.address.trim()+' '+this.zipCode.trim()+' '+this.town.trim()).trim();
		} else if (this.address && this.zipCode && !this.town) {
			return (this.address.trim()+' '+this.zipCode.trim()).trim();
		} else if (this.address && !this.zipCode && this.town) {
			return (this.address.trim()+' '+this.town.trim()).trim();
		} else if (!this.address && this.zipCode && this.town) {
			return (this.zipCode.trim()+' '+this.town.trim()).trim();
		} else if (!this.address && !this.zipCode && this.town) {
			return this.town.trim();
		} else if (this.address && !this.zipCode && !this.town) {
			return this.address.trim();
		} else if (!this.address && this.zipCode && !this.town) {
			return this.zipCode.trim();
		} else {
			return '';
		}
	}

	public get phone(): string {
		return this._phone;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set id(value: number) {
		this._id = value;
	}

	public set name(value: string) {
		this._name = value;
	}

	public set email(value: string) {
		this._email = value;
	}

	public set address(value: string) {
		this._address = value;
	}

	public set zipCode(value: string) {
		this._zipCode = value;
	}

	public set town(value: string) {
		this._town = value;
	}

	public set phone(value: string) {
		this._phone = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			name     : this._name,
			email  : this._email,
			address : this._address,
			zipCode : this._zipCode,
			town : this._town,
			phone   : this._phone,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._name      = data.name;
		this._email   = data.email;
		this._address  = data.address;
		this._zipCode  = data.zipCode;
		this._town  = data.town;
		this._phone    = data.phone;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}